import React, { useContext } from 'react';
import { Text } from 'components/typography/Text';
import { Image } from 'semantic-ui-react';
import userSrc from 'assets/media/user.png';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import classNames from 'classnames';
import { UserAdministrationModalContext } from '../../../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export const UserItem = ({ user }) => {

  const { selectedUser, setSelectedUser, setIsAddingUser, setIsPrimaryResidentAddress, setService } = useContext(
    UserAdministrationModalContext,
  );

  const { checkPermissionsByEmail } = useUserPermissionsByEmail(selectedUser?.email);
  const canReadAdminAddress = checkPermissionsByEmail('admin-address', 'read');

  const onUserClick = () => {
    setSelectedUser(user);
    setIsAddingUser(false);
    setService('');
    setIsPrimaryResidentAddress(!!canReadAdminAddress);
  };

  const classNameByUserStatus = user?.disabled ? classNames(styles.userCard, styles.disabled) : styles.userCard;

  return (
    <div
      className={classNameByUserStatus}
      onClick={onUserClick}
    >
      <div className={styles.details}>
        <Image
          className={styles.img}
          id="user-avatar"
          alt="user-avatar"
          src={userSrc}
          size="tiny"
          circular
        />

        <Text
          size={14}
          uppercase
        >
          {user.firstName} {user.lastName}
        </Text>
      </div>

      <ShouldRender condition={selectedUser && selectedUser.id === user.id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
